/**
 * HomeARSiteHeaderLanguagesView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeARSiteHeaderLanguages
 */

import { useHomeARSiteHeaderLanguagesLogic } from '@/hooks/traits/useHomeARSiteHeaderLanguagesLogic';
import type { HomeARSiteHeaderLanguagesConfig } from '@/hooks/traits/useHomeARSiteHeaderLanguagesLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeARAlmadarHomeView as HomeARAlmadarHomeViewEntity } from '@app/shared';
import { Button } from '@almadar/ui/components';
import { Menu } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeARSiteHeaderLanguagesViewProps {
  config?: Partial<HomeARSiteHeaderLanguagesConfig>;
}

export function HomeARSiteHeaderLanguagesView({ config: propsConfig }: HomeARSiteHeaderLanguagesViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeARSiteHeaderLanguagesLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeARAlmadarHomeView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeAR" trait="HomeARSiteHeaderLanguages">
      {slotWriter['main'] === 'INIT' ? (<Menu trigger={<Button variant="ghost" icon="globe" size="sm" label={String(__locale.toUpperCase())} />} items={Array.isArray(([{ code: "en" as const, href: "/" as const, label: "English" as const }, { label: "العربية" as const, code: "ar" as const, href: "/ar" as const }, { label: "Slovenščina" as const, href: "/sl" as const, code: "sl" as const }]).map((entry) => ({ label: (getNestedValue(entry, "label") ?? ""), href: (getNestedValue(entry, "href") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), id: (getNestedValue(entry, "code") ?? "") }))) ? (((([{ code: "en" as const, href: "/" as const, label: "English" as const }, { label: "العربية" as const, code: "ar" as const, href: "/ar" as const }, { label: "Slovenščina" as const, href: "/sl" as const, code: "sl" as const }]).map((entry) => ({ label: (getNestedValue(entry, "label") ?? ""), href: (getNestedValue(entry, "href") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), id: (getNestedValue(entry, "code") ?? "") }))) as EntityRow[]) as ({ badge?: string | number; disabled?: boolean; event?: string; href?: string; icon?: string; id?: string; label: string; onClick?: never; subMenu?: never[]; title?: string; type?: 'item' | 'divider'; url?: string; variant?: 'default' | 'danger' })[]) : []} className={((([{ label: "English" as const, href: "/" as const, code: "en" as const }, { label: "العربية" as const, code: "ar" as const, href: "/ar" as const }, { code: "sl" as const, href: "/sl" as const, label: "Slovenščina" as const }]).length === 0)) ? "hidden" : ""} position="bottom-end" />) : null}
    </TraitScopeProvider>
  );
}

export default HomeARSiteHeaderLanguagesView;
